import { Button, Card, Col, ConfigProvider, Form, Row } from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import RadioField from "../shared/RadioField";
import InputField from "../shared/InputField";
import handleRsponse from "../../helper/handleRsponse";
import basicInfoRepo from "../../repository/basicInfoRepo";
import SelectField from "../shared/SelectField";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import NewRadioField from "../shared/NewRadioField";
import Utility, { notifyPlacement, notifyType } from "../../helper/utility";
import counselRepo from "../../repository/counselRepo";
const RegisterServiceQrCode = (props) => {
  const [registerResult, setRegisterResult] = useState("");
  const [isSuccess, setIssuccess] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);   
  const [councelTypeList, setCounselTypeList] = useState([]);  
  
  const [form] = Form.useForm();
  useEffect(() => {
    handleRsponse.handleAxios(
      basicInfoRepo.getList(`typeId=11&parentId=0`),
      fillCounselType,
      setIsLoaded
    );
  }, []);  

  const onFinish = (values) => {
    const model = {      
      ...values,      
    };
    
    handleRsponse.handleAxios(
      counselRepo.registerCounsel(model),
      aftersave,
      setIsLoaded
    );
  };
  const aftersave = (response) => {
    if (response.status === 200) {
      //console.log(response, 'responseData');
      if (response.data.isSuccess) {
        Utility.openNotification(
          notifyType.success,
          notifyPlacement.bottomLeft,
          "موفق",
          response.data.data
        );
        setIssuccess(true);
        setRegisterResult(response.data.data);
      } else
        Utility.openNotification(
          notifyType.error,
          notifyPlacement.bottomLeft,
          "خطا",
          response.data.message
        );
    } else {
      if (response.status == 400) {
        Utility.openNotification(
          notifyType.error,
          notifyPlacement.bottomLeft,
          response.data.data.title,
          response.data.data.errors
        );
      }
    }
  };
  const fillCounselType = (response) =>
    setCounselTypeList(handleRsponse.getResponse(response)); 
  return (
    <div
      style={{
        maxHeight: "810px",
        overflowY: "auto",
        position: "relative",
        display: "block",
      }}
    >
      {!isSuccess ? (
        <ConfigProvider direction="rtl">
          <Card className="festival">
            <Form
              form={form}
              onFinish={onFinish}
              
            >
              <Row>             
               <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <InputField
                    name="mobile"
                    label="موبایل"
                    placeholder="موبایل خود را وارد نمایید"                   
                    maxLength="11"
                    rules={[
                                
                                {
                                    pattern: new RegExp("09[0-909][0-9]-?[0-9]{3}-?[0-9]{4}"),
                                    message: "شماره موبایل صحیح نمی باشد"
                                },
                            ]}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <SelectField
                    name="councelTypeId"
                    label="نوع شکایت"
                    placeholder="نوع شکایت خود را انتخاب نمایید"
                    list={councelTypeList}
                    
                  />
                </Col>
                
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <InputField
                    name="description"
                    label="توضیحات"
                    placeholder="توضیحات"
                    inputType="TextArea"
                  />
                </Col>
              </Row>
              <br />
              <Form.Item>
                <Button type="primary" danger htmlType="submit" style={{ 'position': 'relative', 'right': '49.9%' }}>
                  ثبت
                </Button>
              </Form.Item>
            </Form>
            {!isLoaded ? <span>منتظر بمانید...</span> : ""}
          </Card>
        </ConfigProvider>
      ) : (
        <center>
          <br />
          <p style={{ color: '#000' }}>باتشکر از شما</p>
          <p style={{ color: '#000' }}>
            <strong>{registerResult}</strong>
          </p>
        </center>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, null)(RegisterServiceQrCode);
